<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listProtocoloType"
        title-table="Tipo Protocolo"
        module="protocolTypeSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_TIPO_PROTOCOLO_INSERIR'"
        :delete-permission="'ROLE_TIPO_PROTOCOLO_DELETAR'"
        :view-permission="'ROLE_TIPO_PROTOCOLO_CONSULTAR'"
        :edit-permission="'ROLE_TIPO_PROTOCOLO_ATUALIZAR'"
        @add="addNew"
        @edit="edit"
      />
      <FormProtocolType
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'

import FormProtocolType from './forms/FormProtocolType.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormProtocolType,
  },
  computed: {
    ...mapState('protocolTypeSettingsModule', {
      listProtocoloType: state => state.listProtocolType,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Dia Para Vencimento',
          field: 'diaParaVencimento',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('protocolTypeSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
